import { Enemy } from './Enemy.js'
import { PLAYER_DAMAGE } from '../game/CombatBalance.js'

export class Zombie extends Enemy {
  constructor(game, x, y, id) {
    super(game, x, y, id, 'zombie')
    
    this.maxHealth = 40
    this.health = 40
    this.damage = PLAYER_DAMAGE.LIGHT
    this.moveSpeed = 2.5
    this.attackRange = 1.2
    this.attackCooldown = 1.5
    this.detectionRange = 12
  }
  
  dropLoot() {
    if (Math.random() < 0.25) {
      this.game.itemManager.spawnItem({
        type: 'heart',
        id: 'heart',
        name: 'Heart',
        count: 1
      }, { x: this.x, y: this.y })
    }
  }
}
